import React from "react";

export default function PppSecretDetailModal({ isOpen, onClose, data }) {
  if (!isOpen || !data) return null;

  const renderRow = (label, value) => (
    <div className="grid grid-cols-3 gap-2 py-1">
      <div className="text-sm text-slate-500">{label}</div>
      <div className="col-span-2 text-sm font-medium text-slate-800 dark:text-slate-200">
        {value ?? "-"}
      </div>
    </div>
  );

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-3xl rounded-lg bg-white dark:bg-slate-900 shadow-lg">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b dark:border-slate-700">
          <h2 className="text-lg font-semibold">PPP Secret Detail</h2>
          <button
            onClick={onClose}
            className="text-slate-500 hover:text-red-500"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-4 space-y-4 max-h-[70vh] overflow-y-auto">
          {/* Device Info */}
          <div>
            <h3 className="mb-2 text-sm font-semibold text-slate-600 dark:text-slate-400">
              Device
            </h3>
            <div className="rounded border p-3 dark:border-slate-700">
              {renderRow("Device ID", data.device_id)}
              {renderRow("Device Name", data.device_name)}
            </div>
          </div>

          {/* PPP Secret Info */}
          <div>
            <h3 className="mb-2 text-sm font-semibold text-slate-600 dark:text-slate-400">
              PPP Secret
            </h3>
            <div className="rounded border p-3 dark:border-slate-700">
              {renderRow("Name", data.name)}
              {renderRow("Service", data.service)}
              {renderRow("Profile", data.profile)}
              {renderRow("Caller ID", data.caller_id)}
              {renderRow("Customer ID", data.customer_id)}
              {renderRow("Disabled", data.disabled ? "Yes" : "No")}
            </div>
          </div>

          {/* Billing & Customer Status */}
          <div>
            <h3 className="mb-2 text-sm font-semibold text-slate-600 dark:text-slate-400">
              Status
            </h3>
            <div className="rounded border p-3 dark:border-slate-700">
              {renderRow("Billing Status", data.bill_status)}
              {renderRow("Billing Note", data.bill_note)}
              {renderRow("Customer Status", data.cust_status)}
              {renderRow("Customer Note", data.cust_note)}
              {renderRow("Admin Note", data.admin_note)}
            </div>
          </div>

          {/* Technical */}
          <div>
            <h3 className="mb-2 text-sm font-semibold text-slate-600 dark:text-slate-400">
              Technical
            </h3>
            <div className="rounded border p-3 dark:border-slate-700">
              {renderRow("Limit Bytes In", data.limit_bytes_in)}
              {renderRow("Limit Bytes Out", data.limit_bytes_out)}
              {renderRow("Last Caller ID", data.last_caller_id)}
              {renderRow("Last Disconnect Reason", data.last_disconnect_reason)}
              {renderRow(
                "Last Logged Out",
                data.last_logged_out
                  ? new Date(data.last_logged_out).toLocaleString()
                  : "-"
              )}
            </div>
          </div>

          {/* Metadata */}
          <div>
            <h3 className="mb-2 text-sm font-semibold text-slate-600 dark:text-slate-400">
              Metadata
            </h3>
            <div className="rounded border p-3 dark:border-slate-700">
              {renderRow(
                "Created At",
                new Date(data.created_at).toLocaleString()
              )}
              {renderRow(
                "Updated At",
                new Date(data.updated_at).toLocaleString()
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end px-6 py-4 border-t dark:border-slate-700">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm rounded bg-slate-600 hover:bg-slate-700 text-white"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
